var React = require('react');

function SmileyUnpleasedLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24 48a24 24 0 110-48 24 24 0 010 48zm0-46a22 22 0 100 44 22 22 0 000-44z","key":0}),React.createElement("path",{"d":"M21 39.22a1 1 0 01-.84-1.54 14.53 14.53 0 0115-6.44 1.02 1.02 0 01.017 1.997 1.02 1.02 0 01-.397.003 12.56 12.56 0 00-13 5.56.999.999 0 01-.78.42zM16.5 21.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm15 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z","key":1})]);
}

SmileyUnpleasedLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = SmileyUnpleasedLight;

SmileyUnpleasedLight.default = SmileyUnpleasedLight;
